module.exports = __webpack_public_path__ + "img/logo.07f3833e.png";